import * as PropTypes from 'prop-types'

import routes from 'routes'
import {translatedUrl} from 'i18n/utils'

import {
  NotificationWrapper,
  NotificationIcon,
  NotificationCountLabel,
} from './NotificationItem.styles'

const NotificationItem = ({messagesCount, id}) => (
  <NotificationWrapper id={id} to={translatedUrl(routes.notifications.path)}>
    <NotificationIcon />
    {messagesCount > 0 && <NotificationCountLabel>{messagesCount}</NotificationCountLabel>}
  </NotificationWrapper>
)

NotificationItem.propTypes = {
  messagesCount: PropTypes.number,
  id: PropTypes.string,
}
NotificationItem.defaultProps = {
  messagesCount: 0,
}

export default NotificationItem
